import styled, { CSSProperties, css } from "styled-components";
import { getSizeInPx, getSizeInRem } from "../methods/common";
import { scrollBarStyle__hidden } from "../mixins/scrollbar";
export type ContainerPropsType = Pick<
    CSSProperties,
    | "margin"
    | "padding"
    | "width"
    | "height"
    | "border"
    | "borderRadius"
    | "display"
    | "gridTemplateColumns"
    | "gridTemplateRows"
    | "gridAutoFlow"
    | "gap"
    | "justifyContent"
    | "alignItems"
    | "placeItems"
> & {
    hideScrollBar?: boolean;
};

const Container = styled.div<ContainerPropsType>`
    display: ${({ display }) => display};
    gap: ${({ gap }) => getSizeInPx(gap)};

    margin: ${({ margin }) => getSizeInRem(margin) ?? "0"};
    padding: ${({ padding }) => getSizeInRem(padding) ?? "0"};
    border: ${({ border }) => border};

    ${({ width, height, borderRadius }) =>
        css({
            width: getSizeInRem(width),
            height: getSizeInRem(height),
            borderRadius: getSizeInRem(borderRadius),
        })};

    ${({
        gridAutoFlow,
        gridTemplateColumns,
        gridTemplateRows,
        alignItems,
        justifyContent,
    }) =>
        css({
            gridAutoFlow,
            gridTemplateColumns,
            gridTemplateRows,
            alignItems,
            justifyContent,
        })};

    ${({ hideScrollBar }) => hideScrollBar && scrollBarStyle__hidden};
`;

export default Container;
